// extracted by mini-css-extract-plugin
export default {"table":"_8Pr46wo-MG","empty-message":"NvdY27LGb3","emptyMessage":"NvdY27LGb3","section-header":"C0LMmlfmQg","sectionHeader":"C0LMmlfmQg","section-body":"bAlgPbPZRR","sectionBody":"bAlgPbPZRR","section-footer":"+Wr4TBuV+Z","sectionFooter":"+Wr4TBuV+Z"};
    if(module.hot) {
      // 1650538076008
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  